import React from 'react'
import { 
    MainContent, 
    CardImage,
    CardHeader,
    CardFee,
    CardAmount,
    CardCredited,
    CardRenewalFee,
    CardRenewalAmount,
    CardFeeWaived,
    CardCreditedHighlight
} from './styles';
import isMobile from 'tcp-common/lib/utils/is-mobile'

const Card = (props) => {
    const isMobileView = isMobile()

    const renderDesktopView = () => <MainContent flexDirection='column'>
            <CardHeader>{props.cardHeader}</CardHeader>
            <CardFee>{props.cardFee}</CardFee>
            <CardAmount><del>{props.cardStrikeAmount}</del> {props.cardAmount}</CardAmount>
            <CardCredited><CardCreditedHighlight>{props.cardCreditedHighlight}</CardCreditedHighlight> {props.cardCredited}</CardCredited>
            <CardRenewalFee>{props.cardRenewalFee}</CardRenewalFee>
            <CardRenewalAmount>{props.cardRenewalAmount}</CardRenewalAmount>
            <CardFeeWaived>{props.cardFeeWaived}</CardFeeWaived>
            <CardImage src='./Right gradient strokes 1.png' alt="NeuCard fees card background" loading="lazy"></CardImage>
        </MainContent>

    const renderMobileView = () => <MainContent flexDirection='column'>
        <CardHeader>{props.cardHeader}</CardHeader>
        <CardFee>{props.cardFee}</CardFee>
        <CardAmount><del>{props.cardStrikeAmount}</del> {props.cardAmount}</CardAmount>
        <CardCredited><CardCreditedHighlight>{props.cardCreditedHighlight}</CardCreditedHighlight> {props.cardCredited}</CardCredited>
        <CardRenewalFee>{props.cardRenewalFee}</CardRenewalFee>
        <CardRenewalAmount>{props.cardRenewalAmount}</CardRenewalAmount>
        <CardFeeWaived>{props.cardFeeWaived}</CardFeeWaived>
        <CardImage src='./Right gradient strokes 1.png' alt="NeuCard fees card background" loading="lazy"></CardImage>
    </MainContent>

    const renderView = () => isMobileView ? renderMobileView() : renderDesktopView()
    
    return renderView();
}

export default Card
